import { selectColorCode } from '../../util/selectColorCode';
import { ColorSet, ColorDefines } from '../../interface/IColors';

export function dispatchBalloonColors(colors: ColorDefines) {
  const icon: ColorSet = {
    primary: selectColorCode([colors?.balloon?.icon?.primary, colors?.balloon?.primary, colors?.primary]),
    secondary: selectColorCode([colors?.balloon?.icon?.secondary, colors?.balloon?.secondary, colors?.secondary]),
    font: selectColorCode([colors?.balloon?.icon?.font, colors?.balloon?.font, colors?.font]),
  };
  const left: ColorSet = {
    primary: selectColorCode([colors?.balloon?.left?.primary, colors?.balloon?.primary, colors?.primary]),
    secondary: selectColorCode([colors?.balloon?.left?.secondary, colors?.balloon?.secondary, colors?.secondary]),
    font: selectColorCode([colors?.balloon?.left?.font, colors?.balloon?.font, colors?.font]),
  };
  const right: ColorSet = {
    primary: selectColorCode([colors?.balloon?.right?.primary, colors?.balloon?.primary, colors?.primary]),
    secondary: selectColorCode([colors?.balloon?.right?.secondary, colors?.balloon?.secondary, colors?.secondary]),
    font: selectColorCode([colors?.balloon?.right?.font, colors?.balloon?.font, colors?.font]),
  };
  const center: ColorSet = {
    primary: selectColorCode([colors?.balloon?.center?.primary, colors?.balloon?.primary, colors?.primary]),
    secondary: selectColorCode([colors?.balloon?.center?.secondary, colors?.balloon?.secondary, colors?.secondary]),
    font: selectColorCode([colors?.balloon?.center?.font, colors?.balloon?.font, colors?.font]),
  };
  return { icon, left, right, center };
}
